import { format } from 'date-fns';
import React from 'react';
import { useParams } from 'react-router-dom';
import { v4 as uuidv4 } from 'uuid';

import useTranslation from '@hooks/useTranslation';

import { useSensorLogsQuery } from '@pages/SensorDetails/services/useSensorLogsQuery';

import HistoryTableLogsSkeleton from './HistoryTableSensorLogsSkeleton';
import style from './style.module.scss';

interface IProps {
  dateFormat: string;
  isPointLoading?: boolean;
}

const HistoryTableSensorLogs: React.FC<IProps> = ({ dateFormat, isPointLoading }) => {
  const { t } = useTranslation();

  const { pointId } = useParams();

  const { data: sensorLogsData, isLoading: isSensorLogsLoading } = useSensorLogsQuery({ pointId });

  return (
    <table className={style.historySensorLogsTable} cellSpacing="0" cellPadding="0">
      <thead>
        <tr>
          <th>{t('Replacement info')}</th>
          <th>{t('User Name')}</th>
        </tr>
      </thead>
      <tbody>
        {isPointLoading || isSensorLogsLoading ? (
          <HistoryTableLogsSkeleton />
        ) : sensorLogsData?.length ? (
          sensorLogsData?.map((log) => (
            <tr key={uuidv4()} className={style.sensorLogRow}>
              <td className={style.sensorLogRowBlock}>
                <div className={style.infoTitle}>{log.eventText}</div>
                <p className={style.infoDate}>{format(log.timeCreated, dateFormat)}</p>
              </td>
              <td>{log.userName}</td>
            </tr>
          ))
        ) : (
          <tr className={style.emptyRow}>
            <td className={style.emptyRowBlock} colSpan={2}>
              {t('No sensor replacement info')}
            </td>
          </tr>
        )}
      </tbody>
    </table>
  );
};

export default HistoryTableSensorLogs;
